import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerLabelColumn, QueryCustomerLabelRequest, QueryCustomerLabelResponse, SendCustomerLabelRequest, UpdateCustomerLabelDetailRequest, UpdateCustomerLabelHeaderRequest} from '../pages/customer-label/bean/customer-label';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CustomerLabelService {

    // 代表客標Header欄位中可編輯的欄位 (客標Header和MoveOrder有關)
    readonly editableCustomerLabelHeaderColumns: Set<CustomerLabelColumn>  = new Set([
      CustomerLabelColumn.labelKey,
      CustomerLabelColumn.idFromCu
    ]);

    // 代表客標Detail欄位中可編輯的欄位
    readonly editableCustomerLabelDetailColumns: Set<CustomerLabelColumn>  = new Set([
      CustomerLabelColumn.altSku,
      CustomerLabelColumn.altSkuDescr,
      CustomerLabelColumn.altSkuSpecDescr,
      CustomerLabelColumn.docSku,
      CustomerLabelColumn.externWorkOrder,
      CustomerLabelColumn.retailSku,
      CustomerLabelColumn.custLabel01,
      CustomerLabelColumn.custLabel02,
      CustomerLabelColumn.custLabel03,
      CustomerLabelColumn.custLabel04,
      CustomerLabelColumn.custLabel05,
      CustomerLabelColumn.glAttribute01,
      CustomerLabelColumn.glAttribute02,
      CustomerLabelColumn.glAttribute03,
      CustomerLabelColumn.glAttribute04,
      CustomerLabelColumn.glAttribute05
    ]);

    // isCustEditable 此boolean值，表示editableCustLabelColumns欄位可否編輯
    readonly custLabelColumns: Set<CustomerLabelColumn>  = new Set([
      CustomerLabelColumn.custLabel01,
      CustomerLabelColumn.custLabel02,
      CustomerLabelColumn.custLabel03,
      CustomerLabelColumn.custLabel04,
      CustomerLabelColumn.custLabel05,
      CustomerLabelColumn.glAttribute01,
      CustomerLabelColumn.glAttribute02,
      CustomerLabelColumn.glAttribute03,
      CustomerLabelColumn.glAttribute04,
      CustomerLabelColumn.glAttribute05
    ]);

  constructor(
        private http: HttpClient
  ) { }

  searchCustomerLabels(request: QueryCustomerLabelRequest): Observable<QueryCustomerLabelResponse> {
    const url = `${environment.logisticsApiUrl}/customerLabel/query`;
    return this.http.post<QueryCustomerLabelResponse>(url, request);
  }

  updateCustomerLabelHeader(request: UpdateCustomerLabelHeaderRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/customerLabel/updateHeader`;
    return this.http.post<void>(url, request);
  }

  updateCustomerLabelDetail(request: UpdateCustomerLabelDetailRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/customerLabel/updateDetail`;
    return this.http.post<void>(url, request);
  }

  sendMail(request: SendCustomerLabelRequest): Observable<void> {
    const url = `${environment.logisticsApiUrl}/customerLabel/send`;
    return this.http.post<void>(url, request);
  }
  
  isCustomerLabelHeaderEditable(colField: string): boolean {
    return this.editableCustomerLabelHeaderColumns.has(colField as CustomerLabelColumn);
  }
  // 傳入欄位名稱及isCustEditable判斷該欄位是否可編輯
  // isCustEditable 此boolean值，表示custLabelColumns欄位可否編輯
  isCustomerLabelDetailEditable(colField: string, isCustEditable: boolean): boolean {
    if(this.editableCustomerLabelDetailColumns.has(colField as CustomerLabelColumn)){
      if(this.custLabelColumns.has(colField as CustomerLabelColumn) && !isCustEditable)
        return false;
      else return true;
    }else return false;
  }
}
